<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div :class="'view-con-list view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-table :data="conLists" style="width: 100%" class="tab-list-tit">
            <el-table-column prop="custfullname" label="控制人全称" align="center" />
            <el-table-column prop="certificatetype" label="控制人证件类型" align="center" :formatter="certyFormat" />
            <el-table-column prop="certificateno" label="控制人证件号" align="center" />
            <el-table-column prop="taxesplace" label="税收居民国（地区）" align="center" :formatter="countyFormat" />
            <el-table-column prop="taxestype" label="控制人税收类型" align="center" :formatter="taxtyFormat" />
            <el-table-column label="操作" align="center" width="250">
                <template slot-scope="scope">
                    <div class="btn-group">
                        <el-button type="yellow" size="small" v-on:click.once="$router.push({name:'controlinfo',query:{taxiesinfoid:scope.row.taxiesinfoid,taxesflag:taxesflag}})">
                            详情/修改
                        </el-button>
                        <el-button
                            type="red"
                            size="small"
                            v-on:click="delTaxes(scope.row.taxiesinfoid)"
                        >
                            删除
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row>
            <div class="addTax">
                <el-button type="yellow" v-on:click.once="$router.push({name:'controlinfo',query:{lock:'0',taxesflag:taxesflag}})">
                    <i
                        class="fa fa-plus-circle"
                    /><span>新增控制人信息</span>
                </el-button>
            </div>
        </el-row>
        <el-dialog
            title="交易密码"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="prompt-info">
                <p class="clear">
                </p>
            </div>
            <div class="investor-tips">
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    label-width="108px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                        <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    取消
                </el-button>
                <el-button type="yellow" v-on:click="delTaxesInfo">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "TaxesList",
    mixins: [mixin],
    data () {
        return {
            taxestypes: [],
            conLists: [],
            birth: "",
            dialogVisible: false,
            ruleForm: {},
            taxiesinfoid: "",
            pagecount: "0",
            pageoffset: "0",
            allPage: "0",
            total: "0",
            taxesflag: ""
        };
    },
    created () {
        const info = this.$cache.getUser();
        this.isPwdCheck = this.$cache.getPwdCheck("T5");
        this.taxesflag = this.$route.query.taxesflag;
        this.getTaxesInfo();
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
    },
    methods: {
        certyFormat (row, column, value) {
            return this.$cache.getDict("130007", value);
        },
        countyFormat (row, column, value) {
            return this.$cache.getDict("120109", value) || "--";
        },
        taxtyFormat (row, column, value) {
            return this.$cache.getDict("120043", value);
        },
        // 删除税收居民信息
        delTaxes (id) {
            const _this = this;
            _this.taxiesinfoid = id;
            this.$confirm("您确认删除该税收居民身份信息吗？", "税收居民信息删除", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                if(_this.isPwdCheck == true)
                {
                    _this.dialogVisible = true;
                }
                else {
                    _this.delTaxesInfo();
                }
            });
        },
        delTaxesInfo(){
            const _this = this;
            let tradepwd = "";
            if(_this.ruleForm.pwd) {
                tradepwd = this.$util.enc(_this.ruleForm.pwd);
            }
            _this.$util.request("tax/OrgControlInfo", { taxiesinfoid: _this.taxiesinfoid,tradepwd: tradepwd }, "DELETE").then(res => {
                if (res.data) {
                    _this.dialogVisible = false;
                    _this.conLists = _this.conLists.filter(item => {
                        return item.taxiesinfoid !== _this.taxiesinfoid;
                    });
                    _this.$message({
                        type: "success",
                        message: "删除成功!"
                    });
                }
            });

        },
        nextPage(val){
            this.pageoffset = (val - 1) * this.pagecount;
            this.getTaxesInfo();
        },
        getTaxesInfo () {
            const _this = this;
            const _x = {
                pagecount: _this.pagecount,
                pageoffset: _this.pageoffset
            };
            this.$util.request("tax/OrgControlInfo",_x).then(res => {
                if (res.data) {
                    const _info = _this.$cache.getUser();
                    for (let item in res.data[0][0]) {
                        res.data[0][0][item] = res.data[0][0][item].trim();
                    }
                    _this.conLists = res.data;
                    _this.allPage = res.alllength || "0";
                    // for (let i = 0; i < res.data.length; i++) {
                    //     let _obj = {
                    //         custname: _info.custname,
                    //         certificatetype: _info.certificatetype,
                    //         certificateno: _info.certificateno
                    //     };
                    //     _obj.taxesplace = res.data[i].taxesplace || "";
                    //     _obj.taxestype = res.data[i].taxestype || "";
                    //     _obj.taxiesinfoid = res.data[i].taxiesinfoid;
                    //     if (_obj.taxestype.trim()) _this.conLists.push(_obj);
                    // }
                }
            });
        }
    }
};
</script>
<style lang="scss">
/*用户信息 */
.view-con-list {
    padding-bottom: 50px;
    .addTax {
        text-align: center;
        padding: 35px 0;
        .el-button {
            font-size: 16px;
            padding: 7px 20px;
            span {
                vertical-align: middle;
            }
        }
        i {
            font-size: 24px;
            margin-right: 5px;
            vertical-align: middle;
        }
    }
}
</style>
